import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Typography from "../../atoms/Typography/Typography";
import { definedTypographyTypes } from "../../atoms/Typography/TypographyStyles";
import theme from "../../../styles/theme";

export interface NoResultsBannerProps {
  query?: string;
}

const StyledSegment = styled.div`
  &&& {
    padding: 2em;
    margin-bottom: 5em;
    background-color: ${theme.palette.mono.white};
    text-align: center;
  }
`;

const NoResultsBanner: React.FC<NoResultsBannerProps> = ({ query }) => {
  const { t } = useTranslation();
  return (
    <StyledSegment>
      <Typography type={definedTypographyTypes.h1} align="center">
        {t("InfoBanners.NoMessage", { query })}
      </Typography>
      <Typography type={definedTypographyTypes.body} align="center">
        {t("InfoBanners.FlavorText")}
      </Typography>
    </StyledSegment>
  );
};

export default NoResultsBanner;
